import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function WholesaleInfoPopup({
  isOpen,
  onClose
}) {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  if (!isOpen) return null;
  const handleOptionSelect = (option: string) => {
    setSelectedOption(option);
  };
  const handleClose = () => {
    setSelectedOption(null);
    onClose();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4" data-id="element-309" data-mp="2m88dm8ncew72">
      <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-310" data-mp="2i76a3fme7xza">
        <div className="bg-blue-600 text-white p-4 flex justify-between items-center" data-id="element-311" data-mp="2vykunqvy878g">
          <h2 className="text-xl font-bold" data-id="element-312" data-mp="2r72uh51r2aoj">Wholesale Account Information</h2>
          <button onClick={handleClose} className="hover:bg-blue-700 rounded-full p-1 transition-colors" data-id="element-313" data-mp="23i0f63ul8tx7">
            <XIcon className="w-6 h-6" data-id="element-314" data-mp="1yhw10kh5kba5" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1" data-id="element-315" data-mp="owd8n0nx5h81">
          {!selectedOption ? <>
              <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-316" data-mp="tueo7bm4yyer">
                Do you have a Wholesale Account?
              </h3>
              <div className="space-y-3" data-id="element-317" data-mp="ym6j1ycbrqap">
                <button onClick={() => handleOptionSelect('yes')} className="w-full bg-green-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-green-700 transition-colors" data-id="element-318" data-mp="13khtobag24tz">
                  Yes, I have a wholesale account
                </button>
                <button onClick={() => handleOptionSelect('no')} className="w-full bg-red-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-red-700 transition-colors" data-id="element-319" data-mp="funidy5rwobu">
                  No, I don't have a wholesale account
                </button>
                <button onClick={() => handleOptionSelect('unsure')} className="w-full bg-gray-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-gray-700 transition-colors" data-id="element-320" data-mp="1vb5u1l4an66l">
                  Not Sure
                </button>
              </div>
            </> : <div className="space-y-4" data-id="element-321" data-mp="572j87bs5vot">
              {selectedOption === 'yes' && <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-322" data-mp="9afmg1rwl4s">
                  <h3 className="text-lg font-semibold text-green-900 mb-3" data-id="element-323" data-mp="38pm0kesx7h4u">
                    Great! You have a wholesale account
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-324" data-mp="3iedq6gaidpcl">
                    <strong data-id="element-325" data-mp="3ifos0ake8n12">Important:</strong> Make sure you use the exact
                    email address associated with your wholesale account in the
                    quote builder to see wholesale pricing.
                  </p>
                </div>}

              {selectedOption === 'no' && <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-326" data-mp="2kx5ja6h0bt6l">
                  <h3 className="text-lg font-semibold text-blue-900 mb-3" data-id="element-327" data-mp="10fo08vzytue2">
                    How to Obtain a Wholesale Account
                  </h3>
                  <ol className="space-y-3 text-gray-700" data-id="element-328" data-mp="rgsq58tsw05h">
                    <li className="flex" data-id="element-329" data-mp="reg16bpmkpix">
                      <span className="font-bold text-blue-600 mr-2" data-id="element-330" data-mp="wekl6bpqs2dw">1.</span>
                      <span data-id="element-331" data-mp="1k57tuz7hew1i">
                        Email a copy of your business license or a legal
                        document with your Taekwondo School name to{' '}
                        <a href="mailto:shane@tkdscore.com" className="text-blue-600 hover:underline font-medium" data-id="element-332" data-mp="1o477d87a414k">
                          shane@tkdscore.com
                        </a>
                      </span>
                    </li>
                    <li className="flex" data-id="element-333" data-mp="3qomj1gm40eh">
                      <span className="font-bold text-blue-600 mr-2" data-id="element-334" data-mp="3rholp4mm1qa">2.</span>
                      <span data-id="element-335" data-mp="j0lduq6jlgd1">
                        Register at{' '}
                        <a href="https://www.tkdscore.com/register" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-medium" data-id="element-336" data-mp="e9mutiu66463">
                          www.tkdscore.com/register
                        </a>{' '}
                        and make sure you indicate what email address you
                        registered
                      </span>
                    </li>
                    <li className="flex" data-id="element-337" data-mp="sxgcd92tfgrb">
                      <span className="font-bold text-blue-600 mr-2" data-id="element-338" data-mp="t0lxkd8bpyhr">3.</span>
                      <span data-id="element-339" data-mp="nywlcu9d7es3">
                        We will respond after upgrading you to wholesale if
                        approved
                      </span>
                    </li>
                    <li className="flex" data-id="element-340" data-mp="38ovp0rjdn1ow">
                      <span className="font-bold text-blue-600 mr-2" data-id="element-341" data-mp="2ylqiedi43kjl">4.</span>
                      <span data-id="element-342" data-mp="2yjm3z1ml7352">
                        Come back and build another quote to see wholesale
                        pricing
                      </span>
                    </li>
                  </ol>
                  <div className="mt-4 pt-4 border-t border-blue-200" data-id="element-343" data-mp="38i1tx19vo6cz">
                    <p className="text-gray-700" data-id="element-344" data-mp="3dc62foyskmg6">
                      <strong data-id="element-345" data-mp="3hcghdr4kan76">Questions?</strong> Contact Shane Merem at{' '}
                      <a href="tel:+15172940315" className="text-blue-600 hover:underline font-medium" data-id="element-346" data-mp="3hekjq4mtbe5c">
                        (517) 294-0315
                      </a>{' '}
                      via Text
                    </p>
                  </div>
                </div>}

              {selectedOption === 'unsure' && <div className="bg-amber-50 border border-amber-200 rounded-lg p-4" data-id="element-347" data-mp="21vg6cyo31b0a">
                  <h3 className="text-lg font-semibold text-amber-900 mb-3" data-id="element-348" data-mp="21xapc7fsmt1q">
                    Not Sure if You Have a Wholesale Account?
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-3" data-id="element-349" data-mp="1owysbpjk6mxk">
                    Try logging in to{' '}
                    <a href="https://www.tkdscore.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline font-medium" data-id="element-350" data-mp="23u9470045utt">
                      www.tkdscore.com
                    </a>{' '}
                    and check if you have wholesale pricing available in your
                    account.
                  </p>
                  <p className="text-gray-700" data-id="element-351" data-mp="2hjt47y2b8dzf">
                    If you need assistance, contact Shane Merem at{' '}
                    <a href="tel:+15172940315" className="text-blue-600 hover:underline font-medium" data-id="element-352" data-mp="2vkx3s7m52s5d">
                      (517) 294-0315
                    </a>{' '}
                    via Text
                  </p>
                </div>}

              <button onClick={() => setSelectedOption(null)} className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-353" data-mp="3f54btyqhxij8">
                ← Back to options
              </button>
            </div>}
        </div>

        <div className="border-t border-gray-200 p-4 bg-gray-50" data-id="element-354" data-mp="2rfa0xmpqm41m">
          <button onClick={handleClose} className="w-full bg-blue-600 text-white px-6 py-3 rounded-md font-bold hover:bg-blue-700 transition-colors" data-id="element-355" data-mp="2w71khdah79i9">
            Close
          </button>
        </div>
      </div>
    </div>;
}